import React from 'react';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';

const Settings: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Settings</h1>
      <p className="section-description">
        Manage and configure your website settings, including site identity, contact details, social media, and SEO optimization.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <Cog6ToothIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Site Identity</h3>
              <p className="feature-description">
                Configure your website's branding and identity:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Site name and description</li>
                <li>Site logo management</li>
                <li>Google Analytics integration</li>
                <li>Branding elements</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <Cog6ToothIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Contact Details</h3>
              <p className="feature-description">
                Manage your contact information:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Contact email address</li>
                <li>Phone number with formatting</li>
                <li>Physical address</li>
                <li>Contact form settings</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <Cog6ToothIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Social Media</h3>
              <p className="feature-description">
                Configure your social media profiles:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Facebook URL</li>
                <li>Twitter URL</li>
                <li>LinkedIn URL</li>
                <li>Instagram URL</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <Cog6ToothIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">SEO Settings</h3>
              <p className="feature-description">
                Optimize your website for search engines:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Meta description</li>
                <li>Meta keywords</li>
                <li>Robots indexing control</li>
                <li>Search engine visibility</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Keep site information up to date</li>
            <li>Use high-quality logo images</li>
            <li>Maintain consistent branding</li>
            <li>Regularly update contact details</li>
            <li>Optimize SEO settings for visibility</li>
            <li>Verify social media URLs</li>
            <li>Test settings after changes</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Settings; 